const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

const revealItems = document.querySelectorAll(".reveal");
const revealObserver = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) entry.target.classList.add("is-visible");
    }
  },
  { threshold: 0.16 }
);

for (const item of revealItems) revealObserver.observe(item);

const setupReadingCopy = () => {
  for (const element of document.querySelectorAll("[data-reading]")) {
    const text = element.textContent.trim().replace(/\s+/g, " ");
    element.innerHTML = text
      .split(" ")
      .map((word) => `<span class="reading-word">${word}</span>`)
      .join(" ");
  }
};

setupReadingCopy();

let hero = document.querySelector("[data-hero]");
let heroSlides = [...document.querySelectorAll("[data-hero-slide]")];
let heroCount = document.querySelector("[data-hero-count]");
let heroPrev = document.querySelector("[data-hero-prev]");
let heroNext = document.querySelector("[data-hero-next]");
const readingSections = [...document.querySelectorAll("[data-reading-section]")];
const storyStage = document.querySelector("[data-story-stage]");
const deck = document.querySelector(".service-deck");

let ticking = false;
let activeHeroIndex = 0;

const renderHero = (index = activeHeroIndex) => {
  if (!hero || heroSlides.length === 0) return;

  activeHeroIndex = (index + heroSlides.length) % heroSlides.length;

  heroSlides.forEach((slide, index) => {
    const active = index === activeHeroIndex ? 1 : 0;
    const opacity = active;
    const scale = active ? 1 : 0.88;
    const contentY = `${(1 - active) * 42}px`;
    const contentScale = 0.96 + active * 0.04;

    slide.classList.toggle("is-active", active === 1);
    slide.setAttribute("aria-hidden", active === 1 ? "false" : "true");
    slide.tabIndex = active === 1 ? 0 : -1;
    slide.style.pointerEvents = active === 1 ? "auto" : "none";
    slide.style.zIndex = active === 1 ? "2" : "1";
    slide.style.setProperty("--slide-opacity", opacity.toFixed(3));
    slide.style.setProperty("--slide-scale", scale.toFixed(3));
    slide.style.setProperty("--hero-media-lift", active.toFixed(3));
    slide.style.setProperty("--content-opacity", opacity.toFixed(3));
    slide.style.setProperty("--content-y", contentY);
    slide.style.setProperty("--content-scale", contentScale.toFixed(3));
  });

  if (heroCount) {
    heroCount.textContent = `${String(activeHeroIndex + 1).padStart(2, "0")} / ${String(heroSlides.length).padStart(2, "0")}`;
  }
};

const updateReading = () => {
  for (const section of readingSections) {
    const reading = section.querySelector("[data-reading]");
    if (!reading) continue;

    const words = [...reading.querySelectorAll(".reading-word")];
    const rect = section.getBoundingClientRect();
    const total = Math.max(1, section.offsetHeight - window.innerHeight);
    const progress = clamp(-rect.top / total);
    const readUntil = Math.floor(progress * (words.length + 5));

    words.forEach((word, index) => {
      word.classList.toggle("is-read", index <= readUntil);
    });
  }
};

const updateStory = () => {
  if (!storyStage) return;

  const rect = storyStage.getBoundingClientRect();
  const total = Math.max(1, storyStage.offsetHeight - window.innerHeight);
  const progress = clamp(-rect.top / total);
  const workOut = clamp((progress - 0.08) / 0.2);
  const journeyIn = clamp((progress - 0.16) / 0.16);
  const journeyOut = clamp((progress - 0.62) / 0.16);
  const journey = journeyIn * (1 - journeyOut);
  const split = clamp((progress - 0.2) / 0.24);
  const card = clamp((progress - 0.42) / 0.18);
  const services = clamp((progress - 0.66) / 0.22);

  storyStage.style.setProperty("--story-work-out", workOut.toFixed(3));
  storyStage.style.setProperty("--story-journey", journey.toFixed(3));
  storyStage.style.setProperty("--story-services", services.toFixed(3));
  storyStage.style.setProperty("--journey-split", split.toFixed(3));
  storyStage.style.setProperty("--journey-card", card.toFixed(3));
};

const onScroll = () => {
  if (ticking) return;
  ticking = true;
    requestAnimationFrame(() => {
    renderHero(activeHeroIndex);
    updateReading();
    updateStory();
    ticking = false;
  });
};

const bindHeroControls = () => {
  heroPrev?.addEventListener("click", () => renderHero(activeHeroIndex - 1));
  heroNext?.addEventListener("click", () => renderHero(activeHeroIndex + 1));
  hero?.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      renderHero(activeHeroIndex + (event.key === "ArrowLeft" ? -1 : 1));
    }
  });
};

bindHeroControls();

// Theme editor setting changes replace the section's DOM, including its buttons.
document.addEventListener("shopify:section:load", (event) => {
  const nextHero = event.target?.querySelector?.("[data-hero]");
  if (!nextHero || nextHero === hero) return;
  hero = nextHero;
  heroSlides = [...hero.querySelectorAll("[data-hero-slide]")];
  heroCount = hero.querySelector("[data-hero-count]");
  heroPrev = hero.querySelector("[data-hero-prev]");
  heroNext = hero.querySelector("[data-hero-next]");
  bindHeroControls();
  renderHero(Math.min(activeHeroIndex, heroSlides.length - 1));
});

document.addEventListener("shopify:block:select", (event) => {
  const selectedSlide = event.target?.closest?.("[data-hero-slide]");
  if (!selectedSlide) return;

  const selectedIndex = heroSlides.indexOf(selectedSlide);
  if (selectedIndex >= 0) renderHero(selectedIndex);
});

window.addEventListener("scroll", onScroll, { passive: true });
window.addEventListener("resize", onScroll);
window.addEventListener("load", onScroll);
renderHero(0);
updateReading();
updateStory();

if (deck) {
  deck.addEventListener("pointermove", (event) => {
    const rect = deck.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    deck.style.transform = `rotateX(${y * -2.5}deg) rotateY(${x * 3}deg)`;
  });

  deck.addEventListener("pointerleave", () => {
    deck.style.transform = "";
  });
}
